export default __webpack_public_path__ + "static/media/join button.84b7d3a4.svg";